import styled from 'styled-components'

export const RegisterPsInfoWrapper = styled.div`
    min-height: 254px;
    padding: var(--gap-24);
`